import apiService from './api';

export interface LoginData {
  email: string;
  password: string;
}

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  role: string;
  is_super_admin: boolean;
  empresa_id: number;
  /** Senha ainda e a provisoria definida por quem criou a conta. */
  deve_trocar_senha?: boolean;
  empresa?: {
    id: number;
    nome: string;
    cnpj: string;
    plano: string;
    logo_url?: string;
    /** URL pronta da logomarca, montada pelo servidor. */
    logo?: string | null;
    codigo_cadastro?: string;
  };
}

export interface AuthResponse {
  success: boolean;
  message: string;
  data: {
    user: AuthUser;
    token: string;
    permissoes?: string[];
  };
}

export const authService = {
  login: async (data: LoginData): Promise<AuthResponse> => {
    const response = await apiService.post<AuthResponse>('/auth/login', data);
    if (response.success && response.data.token) {
      localStorage.setItem('auth_token', response.data.token);
      localStorage.setItem('auth_user', JSON.stringify(response.data.user));
      localStorage.setItem('auth_permissoes', JSON.stringify(response.data.permissoes || []));
    }
    return response;
  },

  trocarSenha: async (data: { senha_atual: string; password: string; password_confirmation: string }) => {
    const resposta = await apiService.post<{ success: boolean; message: string; data: AuthUser }>(
      '/auth/trocar-senha', data,
    );
    // O usuario guardado localmente carrega o "deve_trocar_senha": sem atualizar,
    // o guard de rota continuaria mandando de volta para a tela de troca.
    if (resposta.success) {
      localStorage.setItem('auth_user', JSON.stringify(resposta.data));
    }
    return resposta;
  },


  logout: async (): Promise<void> => {
    try {
      await apiService.post('/auth/logout');
    } catch (e) {
      // ignora erro se token ja expirou
    } finally {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      localStorage.removeItem('auth_permissoes');
    }
  },

  /**
   * Confere quem esta logado e, de quebra, atualiza as permissoes guardadas.
   *
   * A lista e capturada no login. Quando o administrador mexe nas caixas, a
   * sessao de quem ja estava dentro continuaria com a lista antiga ate sair e
   * entrar de novo. Reconsultar aqui e o que faz a mudanca chegar.
   */
  me: async (): Promise<{ success: boolean; data: AuthUser; permissoes?: string[] }> => {
    const resposta = await apiService.get<{ success: boolean; data: AuthUser; permissoes?: string[] }>('/auth/me');
    if (resposta.success) {
      localStorage.setItem('auth_user', JSON.stringify(resposta.data));
      if (resposta.permissoes) {
        localStorage.setItem('auth_permissoes', JSON.stringify(resposta.permissoes));
      }
    }
    return resposta;
  },

  getToken: (): string | null => {
    return localStorage.getItem('auth_token');
  },

  getUser: (): AuthUser | null => {
    const user = localStorage.getItem('auth_user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('auth_token');
  },
};
